@if (isShowInner) {
<task-context-menu-inner
  #taskContextMenuInner
  [isAdvancedControls]="isAdvancedControls()"
  (close)="isShowInner = false"
  [task]="task()"
></task-context-menu-inner>
}
